import { configureStore, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const tokenFromCookie = Cookies.get('token');

const initialState = {
  isAuthenticated: !!tokenFromCookie,
  token: tokenFromCookie || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.token = action.payload;
      Cookies.set('token', action.payload, { expires: 7 }); // expires in 7 days
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
      Cookies.remove('token');
    },
  },
});

export const { login, logout } = authSlice.actions;

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
  },
});

export default store;
